export const IR_ROUTES = {
  irRoot: "/employee/ir",
  installationPlans: "/employee/ir/installation-plans",
} as const;
